import { useEffect, useRef } from 'react';
import useForceRender from '@hooks/useForceRender';
import PropTypes from 'prop-types';
import CustomPropTypes from '@utils/CustomPropTypes';
import getImageSize from '@utils/getImageSize';
import Image from './Image';

function ScaledImage({
  source,
  width: passedWidth = undefined,
  height: passedHeight = undefined,
  sx = undefined,
  ...props
}) {
  const forceRender = useForceRender();

  const loading = useRef(false);
  const width = useRef(passedWidth);
  const height = useRef(passedHeight);

  useEffect(() => {
    if (passedHeight && passedWidth) {
      return;
    }

    if (!passedHeight && !passedWidth) {
    }

    getImageSize(source)
      .then(({ width: originalWidth, height: originalHeight }) => {
        loading.current = true;

        if (passedWidth && !passedHeight) {
          height.current = (passedWidth * originalHeight) / originalWidth;
          width.current = passedWidth;
        } else {
          width.current = (passedHeight * originalWidth) / originalHeight;
          height.current = passedHeight;
        }

        forceRender();
      })
      .catch((err) => {});
  }, [passedHeight, passedWidth, forceRender, source]);

  if (!loading.current) {
    return null;
  }

  return <Image source={source} sx={{ height: height.current, width: width.current, ...sx }} {...props} />;
}

ScaledImage.propTypes = {
  source: PropTypes.any.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  sx: CustomPropTypes.style,
};

export default ScaledImage;
